// src/Pages/PharmacistDashboard/PharmacistReportsAnalytics.js

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
} from '@mui/material';
import { Bar, Line } from 'react-chartjs-2';
import {
  prescriptionTrendsData,
  inventoryTurnoverData,
  financialReportsData,
} from '../../data/pharmacistReportsandAnalyticsMockData';

const PharmacistReportsAnalytics = () => {
  const [filterCategory, setFilterCategory] = useState('');
  const [dateRange, setDateRange] = useState({
    start: '',
    end: '',
  });

  const handleFilterChange = (event) => {
    setFilterCategory(event.target.value);
  };

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setDateRange((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGenerateReport = () => {
    // Logic for generating custom reports based on filters and date range
    alert(
      `Report generated for category: ${filterCategory} from ${dateRange.start} to ${dateRange.end}`
    );
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h4' gutterBottom>
        Reports and Analytics
      </Typography>

      {/* Filters for Custom Reports */}
      <Grid container spacing={3} sx={{ marginBottom: 4 }}>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <InputLabel>Filter by Medication Category</InputLabel>
            <Select
              value={filterCategory}
              onChange={handleFilterChange}
              label='Filter by Medication Category'
            >
              <MenuItem value=''>All Categories</MenuItem>
              <MenuItem value='Mental Health'>Mental Health</MenuItem>
              <MenuItem value='Pain Relievers'>Pain Relievers</MenuItem>
              <MenuItem value='Vitamins'>Vitamins</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label='Start Date'
            name='start'
            type='date'
            InputLabelProps={{ shrink: true }}
            value={dateRange.start}
            onChange={handleDateChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label='End Date'
            name='end'
            type='date'
            InputLabelProps={{ shrink: true }}
            value={dateRange.end}
            onChange={handleDateChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            color='primary'
            fullWidth
            onClick={handleGenerateReport}
          >
            Generate Report
          </Button>
        </Grid>
      </Grid>

      {/* Prescription Trends Chart */}
      <Typography variant='h6' gutterBottom>
        Prescription Trends
      </Typography>
      <Paper elevation={3} sx={{ padding: 3, marginBottom: 4 }}>
        <Line
          data={prescriptionTrendsData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: true, position: 'top' },
            },
          }}
        />
      </Paper>

      {/* Inventory Turnover Chart */}
      <Typography variant='h6' gutterBottom>
        Inventory Turnover
      </Typography>
      <Paper elevation={3} sx={{ padding: 3, marginBottom: 4 }}>
        <Bar
          data={inventoryTurnoverData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: true, position: 'top' },
            },
          }}
        />
      </Paper>

      {/* Financial Reports Summary */}
      <Typography variant='h6' gutterBottom>
        Financial Reports
      </Typography>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Grid container spacing={3}>
          {financialReportsData.map((report, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Typography variant='body1' gutterBottom>
                {report.title}
              </Typography>
              <Typography variant='h5' color='primary' gutterBottom>
                {report.value}
              </Typography>
              <Typography variant='body2' color='textSecondary'>
                {report.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default PharmacistReportsAnalytics;
